/* Sns Api Module */
import { requester } from '@/libs/requester';
import { AT } from '@/libs/translation';
import type { AuthTypeS } from '../../Auth/outbound/share';
import { CertificationTypeS } from '../../Certification/outbound/share';
import { SnsTypeS } from '../outbound/share';
import type { SnsConnectDeleteControllerReqBodyType } from '../type';

export const postSnsSignup = (data: AuthTypeS.SnsSignupControllerReqBodyType) => {
  return requester.post<AuthTypeS.SignupControllerResBodyType>(`/${AT.language}/api/v1/sns/signup`, data);
};

export const postSnsConnect = (form: SnsTypeS.SnsConnectControllerReqBodyType) => {
  return requester.post<AuthTypeS.SigninControllerResBodyType>(`/${AT.language}/api/v1/sns/connect`, form);
};

export const deleteSnsConnect = (form: SnsConnectDeleteControllerReqBodyType) => {
  return requester.post<SnsConnectDeleteControllerReqBodyType>(`/${AT.language}/api/v1/sns/connect/delete`, form);
};

export const postVerifyEmail = (form: CertificationTypeS.VerifyEmailCertificationControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/sns/email/verify`, form);
};
